import { CHAT_STATUS } from "../constants/index.js";
import download from "../utils/download.js";
import { sendVisitorMessage, initiateAdvisorChat, cancelInitMessageRequest } from "./LiveActions.js";
import { hideChatPanel, closeChat } from "./ChatBarActions.js";
import { isAdvisorHandoverAvailable } from "../utils/advisorHandover.js";
import { UPDATE_CHAT, REQUEST_CHAT, RECEIVE_CHAT, SET_CHAT_STATUS, CYCLE_POSITION_MESSAGE, CYCLE_QUEUE_MESSAGE, SAVE_POSITION, ENDING_CHAT, USE_SUGGESTION, SEND_EVENT, RETURN_TO_CHAT, END_CHAT, RATE_CHAT, SKIP_SUBMIT_RATING, GET_CHAT_TRANSCRIPT, LEAVING_QUEUE, BACK_TO_QUEUE, LEAVE_QUEUE, REQUEST_SUBMIT_RATING, RECEIVE_SUBMIT_RATING, REQUEST_CHAT_TRANSCRIPT, RECEIVE_CHAT_TRANSCRIPT, RESET_CHAT_STATE, RESET_CONFIG_STATE, RECEIVE_QUEUE_MESSAGES, RECEIVE_QUEUE_POSITION_MESSAGES, SET_CHATBOT_SENDING, GET_AVERAGE_WAIT_TIME, GET_QUEUE_MESSAGES, REQUEST_AVERAGE_WAIT_TIME, RECEIVE_AVERAGE_WAIT_TIME, REQUEST_QUEUE_MESSAGES } from "./Constants.js";
let controller = null;
function cancelCurrentChatRequest() {
  return () => {
    if (controller) {
      controller.abort();
      controller = null;
    }
    cancelInitMessageRequest();
  };
}
function requestChat(message) {
  return {
    type: REQUEST_CHAT,
    message
  };
}
function receiveChat(result) {
  return {
    type: RECEIVE_CHAT,
    result
  };
}
function setChatbotSending(sending) {
  return {
    type: SET_CHATBOT_SENDING,
    sending
  };
}
function onClickSend({
  message,
  parcelCode,
  silentMessage = "",
  apiClient
}) {
  return async (dispatch, getState) => {
    var _a, _b, _c, _d;
    dispatch(updateChat(message));
    if (!message || message.trim() === "") {
      return;
    }
    const state = getState().chat;
    if (state.chatBot.dfCaseId && state.chatBot.liveAgentUrl) {
      dispatch(sendVisitorMessage(message, apiClient));
    } else {
      dispatch(requestChat(message));
      controller = new AbortController();
      try {
        const response = await apiClient.post(
          "/chat/message",
          null,
          null,
          {
            message,
            parcelCode,
            init: false,
            topicId: (_a = state.config) == null ? void 0 : _a.topicId
          },
          {},
          controller.signal
        );
        dispatch(receiveChat(response));
        const config = getState().chat.config;
        const hasLiveAgentMessage = (_b = response == null ? void 0 : response.messages) == null ? void 0 : _b.some(
          (msg) => (msg == null ? void 0 : msg.type) === "liveagent"
        );
        if (hasLiveAgentMessage) {
          if (isAdvisorHandoverAvailable(response, config)) {
            await dispatch(initiateAdvisorChat(apiClient));
          } else {
            dispatch(setChatStatus(CHAT_STATUS.ADVISOR_BUSY));
          }
        }
      } catch (error) {
        const message2 = ((_c = error == null ? void 0 : error.response) == null ? void 0 : _c.status) === 401 ? "Your chat session has expired. Please refresh or reopen the chat to start a new session." : "The chatbot is unavailable at the moment. Please try again later.";
        dispatch(
          receiveChat({
            messages: [
              {
                type: "default",
                message: message2
              }
            ],
            suggestions: []
          })
        );
      } finally {
        if (controller) {
          (_d = controller.delete) == null ? void 0 : _d.call(controller);
          controller = null;
        }
      }
    }
  };
}
function updateChat(message) {
  return {
    type: UPDATE_CHAT,
    message
  };
}
function useSuggestion(suggestion) {
  return {
    type: USE_SUGGESTION,
    suggestion
  };
}
function returnToChat() {
  return {
    type: RETURN_TO_CHAT
  };
}
function endChat(ratingEnabled) {
  return {
    type: END_CHAT,
    ratingEnabled
  };
}
function setChatStatus(chatStatus) {
  return {
    type: SET_CHAT_STATUS,
    chatStatus
  };
}
function endingChat() {
  return {
    type: ENDING_CHAT
  };
}
function requestSubmitRating() {
  return {
    type: REQUEST_SUBMIT_RATING
  };
}
function receiveSubmitRating() {
  return {
    type: RECEIVE_SUBMIT_RATING
  };
}
function skipSubmitRating() {
  return (dispatch, getState) => {
    dispatch({
      type: SKIP_SUBMIT_RATING
    });
    const state = getState().chat;
    setTimeout(() => {
      dispatch(hideChatPanel());
    }, state.config.timeoutClosure * 1e3);
    setTimeout(
      () => {
        dispatch(closeChat());
      },
      state.config.timeoutClosure * 1e3 + 1e3
    );
  };
}
function fetchUpdateRating(rating, notes, apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestSubmitRating());
    const state = getState().chat;
    await apiClient.post(RATE_CHAT, null, null, {
      advisorName: state.chatBot.dfAdvisorName || "N/A",
      rating,
      customerFeedback: notes
    });
    dispatch(receiveSubmitRating());
    setTimeout(() => {
      dispatch(hideChatPanel());
    }, state.config.timeoutClosure * 1e3);
    setTimeout(
      () => {
        dispatch(closeChat());
      },
      state.config.timeoutClosure * 1e3 + 1e3
    );
  };
}
function useRichContent(content) {
  const obj = document.getElementById("dpdgroup-chatbot-fmp");
  const event = new CustomEvent("dpd/cbot/fmp-action", {
    detail: content
  });
  obj.dispatchEvent(event);
  return {
    type: SEND_EVENT,
    content
  };
}
function requestTranscript() {
  return {
    type: REQUEST_CHAT_TRANSCRIPT
  };
}
function receiveTranscript() {
  return {
    type: RECEIVE_CHAT_TRANSCRIPT
  };
}
function fetchTranscript(apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestTranscript());
    const state = getState().chat;
    const transcript = await apiClient.get(GET_CHAT_TRANSCRIPT, {
      parcelNumber: state.config.parcelNumber
    });
    download("data:application/pdf;base64," + transcript);
    dispatch(receiveTranscript());
  };
}
function requestAverageWaitTime() {
  return {
    type: REQUEST_AVERAGE_WAIT_TIME
  };
}
function receiveAverageWaitTime(waitTime) {
  return {
    type: RECEIVE_AVERAGE_WAIT_TIME,
    waitTime
  };
}
function fetchAverageWaitTime(apiClient) {
  return async (dispatch) => {
    dispatch(requestAverageWaitTime());
    let waitTime = null;
    try {
      waitTime = await apiClient.get(GET_AVERAGE_WAIT_TIME);
    } catch (e) {
      throw new Error(e);
    }
    dispatch(receiveAverageWaitTime(waitTime));
  };
}
function requestQueueMessages() {
  return {
    type: REQUEST_QUEUE_MESSAGES
  };
}
function receiveQueueMessages(queueMessages) {
  return {
    type: RECEIVE_QUEUE_MESSAGES,
    queueMessages
  };
}
function receiveQueuePositionMessages(queueMessages) {
  return {
    type: RECEIVE_QUEUE_POSITION_MESSAGES,
    queueMessages
  };
}
function fetchQueueMessasges(apiClient) {
  return async (dispatch) => {
    dispatch(requestQueueMessages());
    const messages = await apiClient.get(GET_QUEUE_MESSAGES);
    dispatch(receiveQueueMessages(messages));
  };
}
let cycleQueueMessageTimeout = null;
function cycleQueueMessage() {
  return async (dispatch, getState) => {
    clearTimeout(cycleQueueMessageTimeout);
    const state = getState().chat;
    if (!state.chatBot.messages || !state.chatBot.dfQueue || state.chatBot.dfQueue <= 0) {
      cycleQueueMessageTimeout = setTimeout(() => {
        dispatch(cycleQueueMessage());
      }, 1e3);
      return;
    }
    const newMessage = getNextEducationalMessage(
      state.chatBot.queueMessage,
      state.chatBot.messages
    );
    const type = "educational";
    dispatch({
      type: CYCLE_QUEUE_MESSAGE,
      message: {
        id: newMessage.id,
        title: newMessage.message.split(";")[0],
        body: newMessage.message.split(";")[1],
        type,
        waitTime: 40
      }
    });
    cycleQueueMessageTimeout = setTimeout(() => {
      dispatch(cycleQueueMessage());
    }, 40 * 1e3);
  };
}
function cyclePositionMessage() {
  return async (dispatch, getState) => {
    const { dfQueue, messages } = getState().chat.chatBot;
    const newMessage = getQueueMessageForPosition(
      dfQueue,
      messages == null ? void 0 : messages.queueMessages
    );
    newMessage && dispatch({
      type: CYCLE_POSITION_MESSAGE,
      message: {
        id: newMessage.id,
        title: newMessage.message.split(";")[0],
        body: newMessage.message.split(";")[1]
      }
    });
  };
}
function getQueueMessageForPosition(position = 1, messages = []) {
  let currentMessage = null;
  let maxMessage = messages[0];
  messages.forEach((message) => {
    const roundedMessage = Math.ceil(position / 10) * 10;
    if (parseInt(message.queuePosition, 10) > parseInt(maxMessage.queuePosition, 10)) {
      maxMessage = message;
    }
    if (parseInt(message.queuePosition, 10) === roundedMessage) {
      currentMessage = message;
    }
  });
  if (!currentMessage) {
    currentMessage = maxMessage;
  }
  return currentMessage;
}
function getNextEducationalMessage(current, messages) {
  if (!current) {
    let minMessage = messages[0];
    for (let i = 0; i < messages.length; i++) {
      if (messages[i].id < minMessage.id) {
        minMessage = messages[i];
      }
    }
    return minMessage;
  }
  let newMessage = messages[0];
  for (let i = 0; i < messages.length; i++) {
    if (!current || messages[i].id > current.id && (messages[i].id < newMessage.id || newMessage.id === messages[0].id)) {
      newMessage = messages[i];
    }
  }
  return newMessage;
}
function leaveQueue() {
  return {
    type: LEAVE_QUEUE
  };
}
function savePosition(bottom, right) {
  return {
    type: SAVE_POSITION,
    bottom,
    right
  };
}
function leavingQueue() {
  return {
    type: LEAVING_QUEUE
  };
}
function backToQueue() {
  return {
    type: BACK_TO_QUEUE
  };
}
function resetChatState() {
  return {
    type: RESET_CHAT_STATE
  };
}
function resetConfigState() {
  return {
    type: RESET_CONFIG_STATE
  };
}
function callCenterClosed() {
  return { type: CHAT_STATUS.CALL_CENTER_CLOSED };
}
export {
  backToQueue,
  callCenterClosed,
  cancelCurrentChatRequest,
  cyclePositionMessage,
  cycleQueueMessage,
  endChat,
  endingChat,
  fetchAverageWaitTime,
  fetchQueueMessasges,
  fetchTranscript,
  fetchUpdateRating,
  leaveQueue,
  leavingQueue,
  onClickSend,
  receiveQueueMessages,
  receiveQueuePositionMessages,
  resetChatState,
  resetConfigState,
  returnToChat,
  savePosition,
  setChatStatus,
  setChatbotSending,
  skipSubmitRating,
  updateChat,
  useRichContent,
  useSuggestion
};
//# sourceMappingURL=ChatActions.js.map
